var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontatura1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/Glyphs/Product/Frame Material") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/Glyphs/Product/Frame-Material",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.500000, 13.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03063851,0 C4.13370692,0 0,1.3876709 0,5.55068361 C0,9.71369632 1.55788186,13 5.55581009,13 C9.55373832,13 14.5,6.42710734 14.5,3.21355367 C14.5,1.07118456 13.133567,0 10.4007009,0 C8.75194704,0 7.29525956,0 6.03063851,0 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9775145,12.0259781 C30.119123,10.0751551 33,5.66605568 33,3.21355367 C33,1.07118456 31.633567,0 28.9007009,0 C27.251947,0 25.7952596,0 24.5306385,0 C22.6337069,0 18.5,1.3876709 18.5,5.55068361 C18.5,6.40213964 18.5651694,7.21692115 18.7030558,7.97441199",
    id: "Path",
    transform: "translate(25.750000, 6.012989) scale(-1, 1) translate(-25.750000, -6.012989) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766355,0.5 C10.4766355,0.5 14.4922118,0.5 22.5233645,0.5",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,4 C14.5,4 15.8333333,4 18.5,4",
    id: "Path-3-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.906693, 20.335625)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(3.832187, 7.832187) rotate(45.000000) translate(-3.832187, -7.832187) ",
    x: 1.12242171,
    y: 5.12242171,
    width: 5.41953143,
    height: 5.41953143
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(3.832187, 3.832187) rotate(45.000000) translate(-3.832187, -3.832187) ",
    points: "3.95340819 6.54195314 1.12242171 6.54195314 1.12242171 1.12242171 6.54195314 1.12242171 6.54195314 3.91558559"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontatura1);
export default __webpack_public_path__ + "static/media/montatura1.aede92cf39f13c49af493980fc11d37e.svg";
export { ForwardRef as ReactComponent };